import ViewSGBPApplicationFormFeature from "../../features/ViewSGBPApplicationFormFeature/ViewSGBPApplicationFormFeature";
import "./ViewSGBPApplication.scss";

const ViewSGBPApplicationForm = () => {
  return (
    <div>
      <ViewSGBPApplicationFormFeature />
    </div>
  );
};
export default ViewSGBPApplicationForm;
